// ======================================================================
// File Name       : ReportTabMenuAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as actionTypes from '../constants/actionTypes/tabMenu';

export function saveReportActiveTabMenu(key) {
  return {
    type: actionTypes.REPORT_TABMENU_SAVE_ACTIVE_TAB,
    key,
  };
}
